module.exports = __webpack_public_path__ + "9bcd21965285217c5aa75ada61eac5be.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-about.jpg
// module id = 1059
// module chunks = 0